import { useFormik } from "formik";
import * as Yup from "yup";
import { postForm, putForm } from "../../../../../api/util";
import { appendVedhaefeler } from "../../../../../util/email";

export function useMailskabelon(
  initialValues: MailskabelonFormik,
  onSuccess: () => void,
  setModalOpen: (open: boolean) => void,
  action: MailskabelonActionTypes,
  templateId?: number | null,
) {
  return useFormik<MailskabelonFormik>({
    validateOnMount: true,
    initialValues: initialValues,
    validationSchema: Yup.object({
      navn: Yup.string().required("Angiv et navn"),
      afsender: Yup.string()
        .email("E-mail har forkert format")
        .required("Der skal angives en emailadresse for afsender"),
      emne: Yup.string().required("Der skal angives et emne"),
      indhold: Yup.string().required("Indhold kan ikke være blankt"),
      type: Yup.string().required("Type skal være valgt"),
    }),

    onSubmit: async (values) => {
      const { indhold, emne, vedhaeftelser, type, afsender, navn } = values;
      const formData = new FormData();
      formData.append("Navn", navn);
      formData.append("Afsender", afsender);
      formData.append("Emne", emne);
      formData.append("Indhold", indhold);
      formData.append("Type", type);
      if (vedhaeftelser) {
        await appendVedhaefeler(formData, vedhaeftelser);
      }
      let result;
      if (action === "opret") {
        result = await postForm<MailskabelonDTO>({
          query: "email/skabeloner",
          body: formData,
        });
      } else if (action === "rediger") {
        result = await putForm<MailskabelonDTO>({
          query: `email/skabeloner/${templateId}`,
          body: formData,
        });
      }
      if (result) {
        setModalOpen(false);
        onSuccess();
      }
    },
    enableReinitialize: true,
  });
}
